/**
 * KAN-781: чистые функции выбора товара в заказ из каталога.
 *
 * Товары грузятся, когда выбрана категория (с подкатегориями) или введён
 * текст; без того и другого запроса нет. Страницы списка накапливаются,
 * номер следующей берётся из поля next ответа.
 */
import type { CatalogProduct, CatalogProductsParams, CatalogProductsResponse } from '@/types/catalog';

export const PRODUCT_PICKER_PAGE_SIZE = 20;

export interface ProductQueryInput {
  /** id категории или '' (все категории). */
  category: string;
  search: string;
  pageSize: number;
}

/** Параметры запроса без номера страницы; null: запрос не нужен. */
export function productQueryParams({ category, search, pageSize }: ProductQueryInput): CatalogProductsParams | null {
  const text = search.trim();
  if (!category && !text) return null;
  const params: CatalogProductsParams = { page_size: pageSize };
  if (category) {
    params.category = category;
    params.include_children = 1;
  }
  if (text) params.search = text;
  return params;
}

/** Номер следующей страницы по next ответа; undefined: страниц больше нет. */
export function nextCatalogPage(last: CatalogProductsResponse, loadedPages: number): number | undefined {
  return last.next ? loadedPages + 1 : undefined;
}

/** Товары всех загруженных страниц по порядку; повтор id (сдвиг списка) один раз. */
export function flattenProductPages(pages: readonly CatalogProductsResponse[] | undefined): CatalogProduct[] {
  if (!pages) return [];
  const seen = new Set<string>();
  const out: CatalogProduct[] = [];
  pages.forEach((page) =>
    page.results.forEach((product) => {
      const id = String(product.id);
      if (seen.has(id)) return;
      seen.add(id);
      out.push(product);
    })
  );
  return out;
}
